import Cookie from "js-cookie";
import {
  QUIZ_VARIANT_CONTROL,
  QUIZ_VARIANT_TEST_A,
  QUIZ_VARIANT_TEST_B,
  type QuizExperimentVariant,
} from "@/lib/utils/common/constants";

const COOKIE_NAME = "quiz_attribution";

export type TouchpointType =
  | "top_strip"
  | "side_chip"
  | "floating_banner"
  | "inline_section"
  | "inline_section_home"
  | "hero_section";

export interface QuizAttribution {
  quiz_source: string;
  touchpoint_type: TouchpointType;
  disc_code?: string;
}

export function setQuizAttribution(attrs: QuizAttribution): void {
  try {
    Cookie.set(COOKIE_NAME, JSON.stringify(attrs), {
      path: "/",
      sameSite: "lax",
    });
  } catch {
    /* silent – cookie quota / disabled */
  }
}

export function getQuizAttribution(): QuizAttribution | null {
  try {
    const raw = Cookie.get(COOKIE_NAME);
    if (!raw) return null;
    return JSON.parse(raw) as QuizAttribution;
  } catch {
    return null;
  }
}

export function clearQuizAttribution(): void {
  Cookie.remove(COOKIE_NAME, { path: "/" });
}

/**
 * Read the v2 experiment variant from the AB experiment cookie (set by middleware).
 */
export function getExperimentVariant(): QuizExperimentVariant | null {
  const value = Cookie.get("ab_website_quiz_touchpoint_v2");
  if (value === QUIZ_VARIANT_TEST_A || value === QUIZ_VARIANT_TEST_B || value === QUIZ_VARIANT_CONTROL)
    return value;
  return null;
}

/**
 * Returns true when the user is in an experiment arm (test_a or test_b).
 */
export function isQuizTouchpointExperiment(): boolean {
  const v = getExperimentVariant();
  return v === QUIZ_VARIANT_TEST_A || v === QUIZ_VARIANT_TEST_B;
}
